'use client'

// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { useEffect, useState } from 'react';
import { useAtom } from 'jotai';

// lib files
import { searchFiltersAtom } from '@/lib/atoms/search-filters';

// svgs
import SearchIcon from '@/public/svg/search.svg';
import CloseIcon from '@/public/svg/pbs-close-white.svg';

import styles from './SearchInput.module.scss';
import { useRouter } from 'next/navigation';
import { DefaultSearchFiltersObject } from '@/lib/content-services/search/search';

function SearchInput({ query }: { query: string}) {
  const [debouncedTextInput, setDebouncedTextInput] = useState(query)
  const [filters, setFilters] = useAtom(searchFiltersAtom)
  const router = useRouter()

  useEffect(() => {
    // remove accents/diacritics and replace them inline
    // courtesy of https://stackoverflow.com/a/37511463
    const normalizedTextInput = debouncedTextInput?.normalize('NFD')
                                                   .replace(/[\u0300-\u036f]/g, '');

    if(normalizedTextInput === filters.query) {
      return
    }

    const handler = setTimeout(() => {
      router.push(`/search?q=${normalizedTextInput}`)

      setFilters(_previousFilters => {
        return { ...DefaultSearchFiltersObject, query: normalizedTextInput }
      })
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  // Only run this useEffect when deboucedTextInput changes otherwise the timeout
  // can get cleared prematurely.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedTextInput])

  return (
    <div className={styles.text_input} data-sentry-component="SearchInput" data-sentry-source-file="SearchInput.tsx">
      <label className={styles.legend} htmlFor='search_query'>
        Search
      </label>

      <input
        type='text'
        id='search_query'
        className={styles.search_filter_input}
        value={debouncedTextInput}
        onChange={(e) => setDebouncedTextInput(e.target.value)}
        placeholder='Search'
      />

      {debouncedTextInput?.length === 0 && (
        <SearchIcon className={styles.text_input_icon} />
      )}

      {debouncedTextInput?.length > 0 && (
        <button
          className={styles.text_input_clear_button}
          aria-label='Clear text'
          onClick={() => setDebouncedTextInput('')}
        >
          <CloseIcon />
        </button>
      )}
    </div>
  )
}

export default SearchInput
